import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useCheck } from 'api/auth'
import { useModal } from 'hooks'
import useResponsive from 'utils/hooks/useResponsive'
import {
  Button,
  Div,
  TextLink,
  Input,
  Text,
} from 'ui'
import { isValid } from 'ui/Input/validators'
import FormRequirement from '../FormRequirement'

const FormCreateUsername = ({
  email,
  setEmail,
  username,
  setUsername,
  onSuccess,
}) => {

  const { t } = useTranslation()

  const { Modal: ModalLogin } = useModal('login')
  const { isMobile } = useResponsive()

  const {
    check,
    isLoading,
    isSuccess,
    error,
  } = useCheck()

  const [errors, setErrors] = useState({})

  const isValidUsernameLenght = isValid.usernameLength(username)
  const isValidUsernameOneLetter = isValid.usernameHasLetter(username)
  const isValidUsernameCharacters = isValid.usernameCharacters(username)

  const isValidUsername = (
    isValidUsernameLenght
    && isValidUsernameOneLetter
    && isValidUsernameCharacters
  )


  const handleSubmit = (e) => {
    e.preventDefault()

    const emailError = t('emailInvalid')

    if (!isValid.email(email)) {
      setErrors(prev => ({ ...prev, email: emailError }))
      return
    }

    check({ email, nickname: username })
  }

  const handleChangeEmail = (val) => {
    setErrors(prev => ({...prev, email: '' }))
    setEmail(val)
  }

  const handleChangeUsername = (val) => {
    if (!isValid.usernameCharacters(val)) return

    setErrors(prev => ({...prev, nickname: '' }))
    setUsername(val)
  }

  useEffect(() => {
    if (isSuccess) onSuccess()
  }, [isSuccess])

  useEffect(() => {
    if (!error) return

    const alreadyExistErrors = {
      email: t('emailRegistered'),
      nickname: t('usernameRegistered'),
    }


    const newErrors = {}
    error.details.forEach(err => {
      newErrors[err.field] = alreadyExistErrors[err.field]
    })

    setErrors(newErrors)
  }, [error])

  return (
    <Div
      as='form'
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      flexGrow={1}
      minHeight='100%'
      width='100%'
      onSubmit={handleSubmit}
      paddingBottom={isMobile ? 48 : 0}
    >

      <Div>

        <Text
          size='xl'
          color='headline'
          weight='semibold'
          align='center'
        >
          {t('enterEmailAndCreateNewUsername')}
        </Text>


        <Div
          display='flex'
          flexDirection='column'
          gap={16}
          marginTop={32}
          marginBottom={12}
        >
          <Input.Text
            label={t('email')}
            onChange={handleChangeEmail}
            value={email}
            error={errors.email}
            autoFocus
          />

          <Input.Text
            label={t('username')}
            onChange={handleChangeUsername}
            value={username}
            error={errors.nickname}
          />
        </Div>

        <FormRequirement
          isCompleted={isValidUsernameLenght}
          description={t('usernameReq_1')}
        />
        <FormRequirement
          isCompleted={isValidUsernameOneLetter}
          description={t('usernameReq_2')}
        />
      </Div>


      <div>
        <Div marginBottom={16} textAlign='center'>
          <Text as='span' size='xs'>
            {t('termsAndConditions_1')}
          </Text>
          <TextLink size='xs' isInline openNewTab to='terminos-y-condiciones.html'>
            {t('termsAndConditions_2')}
          </TextLink>
          <Text as='span' size='xs'>
            {t('termsAndConditions_3')}
          </Text>
          <TextLink size='xs' isInline openNewTab to='privacypolicy.html'>
            {t('termsAndConditions_4')}
          </TextLink>
          <Text as='span' size='xs'>
            {t('termsAndConditions_5')}
          </Text>
        </Div>

        <Button
          isFull
          size='large'
          isLoading={isLoading}
          disabled={!isValidUsername}
        >
          {t('next')}
        </Button>

        <Div marginTop={16} textAlign='center'>
          <Text as='span' size={isMobile ? 'xs' : 'sm'}>
            {t('alreadyHaveAnAccount')}
          </Text>
          {' '}
          <TextLink
            isInline
            onClick={ModalLogin.open}
            size={isMobile ? 'xs' : 'sm'}
          >
            {t('loginImperative')}
          </TextLink>
        </Div>
      </div>

    </Div>
  )
}

export default FormCreateUsername